<template>
  <v-row>
    <v-dialog
      v-model="$store.state.show.edit_user"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Edit</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="save">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-list three-line subheader>
          <v-subheader>User Edit</v-subheader>
          <v-list-item>
            <v-list-item-content>
              <v-row align="center" justify="start">
                <v-col cols="6" sm="6">
                  <v-list-item-title class="ma-6 mt-0 mb-0"
                    >First name</v-list-item-title
                  >
                  <v-list-item-subtitle>
                    <v-text-field
                      v-model="firstname"
                      class="ma-8 mt-0 mb-0"
                    ></v-text-field>
                  </v-list-item-subtitle>
                </v-col>
                <v-col cols="6" sm="6">
                  <v-list-item-title class="ma-6 mt-0 mb-0"
                    >Last name</v-list-item-title
                  >
                  <v-list-item-subtitle>
                    <v-text-field
                      v-model="lastname"
                      class="ma-8 mt-0 mb-0"
                    ></v-text-field>
                  </v-list-item-subtitle>
                </v-col>
                <v-col cols="6" sm="6">
                  <v-list-item-title class="ma-6 mt-0 mb-0"
                    >Username</v-list-item-title
                  >
                  <v-list-item-subtitle>
                    <v-text-field
                      v-model="username"
                      class="ma-8 mt-0 mb-0"
                    ></v-text-field>
                  </v-list-item-subtitle>
                </v-col>
                <v-col cols="6" sm="6">
                  <v-list-item-title class="ma-6 mt-0 mb-0"
                    >User id</v-list-item-title
                  >
                  <v-list-item-subtitle>
                    <v-text-field
                      v-model="infos.id"
                      disabled
                      class="ma-8 mt-0 mb-0"
                    ></v-text-field>
                  </v-list-item-subtitle>
                </v-col>
                <v-col cols="6" sm="6">
                  <v-list-item-title class="ma-6 mt-0 mb-0"
                    >Email</v-list-item-title
                  >
                  <v-list-item-subtitle>
                    <v-text-field
                      v-model="email"
                      class="ma-8 mt-0 mb-0"
                    ></v-text-field>
                  </v-list-item-subtitle>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list three-line subheader>
          <v-subheader>Gender / Address Edit</v-subheader>
          <v-row align="center" justify="center">
            <v-col cols="12" sm="5">
              <v-radio-group v-model="gender" :mandatory="false">
                <v-row justify="start" class="ml-6">
                  <v-list-item-title class="ma-4 mt-0 mb-0">
                    Gender:
                  </v-list-item-title>
                  <v-col sm="2">
                    <v-radio label="Men" value="male"></v-radio>
                  </v-col>

                  <v-col sm="2">
                    <v-radio label="Women" value="female"></v-radio>
                  </v-col>
                </v-row>
              </v-radio-group>
            </v-col>

            <v-divider class="mx-4" inset vertical></v-divider>

            <v-col cols="12" sm="5">
              <v-list-item-title class="ma-4 mt-0 mb-0"
                >Address</v-list-item-title
              >
              <v-list-item-subtitle>
                <v-textarea
                  v-model="address"
                  class="ml-3 mr-3"
                  label="client address"
                  color="teal"
                  rows="2"
                ></v-textarea>
              </v-list-item-subtitle>
            </v-col>
          </v-row>
        </v-list>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      firstname: "",
      lastname: "",
      username: "",
      email: "",
      gender: "",
      address: "",
    };
  },
  props: {
    infos: {
      type: Object,
      default: () => {},
    },
  },
  created() {
    // console.log("mounter", this.infos);
    this.gender = this.infos.gender;
    this.firstname = this.infos.firstname;
    this.lastname = this.infos.lastname;
    this.username = this.infos.username;
    this.email = this.infos.email;
    this.address = this.infos.address;
  },
  destroyed() {
    this.$store.state.show.edit_user = false;
  },
  methods: {
    close() {
      this.$store.state.show.edit_user = false;
    },
    save() {
      if (this.infos.id && this.infos.guid) {
        let data = {
          firstname: this.firstname,
          lastname: this.lastname,
          username: this.username,
          email: this.email,
          gender: this.gender,
          address: this.address,
          user_id: this.infos.id,
          guid: this.infos.guid,
        };
        this.$store.dispatch("setLoader", {
          showing: true,
          text: "Editing users",
        });
        this.$store
          .dispatch("EDIT_USER", data)
          .then((r) => {
            //users info change
            this.infos.firstname = this.firstname;
            this.infos.lastname = this.lastname;
            this.infos.username = this.username;
            this.infos.email = this.email;
            this.infos.gender = this.gender;
            this.infos.address = this.address;
            this.$store.state.user.users[this.infos.guid] = this.infos;
            // end users info change

            /// messages info chnage
            const index = this.$store.state.messages.filter_rest.findIndex(
              (x) => x.guid === this.infos.guid
            );
            if (index > -1) {
              this.$store.state.messages.filter_rest[
                index
              ].firstname = this.firstname;
              this.$store.state.messages.filter_rest[
                index
              ].lastname = this.lastname;
              this.$store.state.messages.filter_rest[
                index
              ].username = this.username;
              this.$store.state.messages.filter_rest[index].email = this.email;
              this.$store.state.messages.filter_rest[
                index
              ].gender = this.gender;
              this.$store.state.messages.filter_rest[
                index
              ].address = this.address;
              this.$store.state.messages.filter_rest[index].contact =
                this.firstname || this.email || `#${this.id}`;
            }
            /// end messages info chnage
            this.$store.dispatch("setLoader", {
              showing: false,
            });
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: "Data saved",
              color: "success",
            });
            this.$store.state.show.edit_user = false;
          })
          .catch((err) => {
            console.log(err);
            this.$store.dispatch("setLoader", {
              showing: false,
            });
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: `Error in saving data reason : "${
                err.data.err || err.data.message
              }"`,
              color: "error",
              timeout: 6000,
            });
          });
      } else {
        this.$store.dispatch("setSnackbar", {
          showing: true,
          text: `No user id and guid`,
          color: "warning",
          timeout: 6000,
        });
      }
    },
  },
};
</script>
